import { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox';
import { useState } from 'react';

import { UiCheckbox } from 'shared/ui/ui-kit/checkbox';

import { StyledButton } from '../../../../common-styles';
import { FormContentWrapper, StyledButtonsContainer } from './styles';

type Props = {
  onCancel: () => void;
  onConfirm: (val: boolean) => void;
  showCharts: boolean;
};

export function PageSettingsForm({ onCancel, onConfirm, showCharts }: Props) {
  const [show, setShow] = useState(showCharts);

  const handleShowChange = (val: boolean) => setShow(val);

  const onCheckboxChange = (e: CheckboxChangeEvent) => {
    handleShowChange(e.target.checked);
  };

  return (
    <>
      <FormContentWrapper>
        <UiCheckbox checked={show} onChange={onCheckboxChange}>
          Показывать графики
        </UiCheckbox>
      </FormContentWrapper>
      <StyledButtonsContainer>
        <StyledButton type="primary" onClick={onCancel}>
          Отмена
        </StyledButton>
        <StyledButton
          type="default"
          onClick={() => {
            onConfirm(show);
            onCancel();
          }}
        >
          Да
        </StyledButton>
      </StyledButtonsContainer>
    </>
  );
}
